// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetAttributeCodeApprvService = {};

AssetAttributeCodeApprvService.getAssetAttributeCodeApprvList = function (
  userInput
) {
  return lossClient({
    url: "/AssetAttribute/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default AssetAttributeCodeApprvService;
